import React, { lazy, Suspense, Fragment } from "react";
var ExecutionEnvironment = require("exenv");
import { connect } from "react-redux";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const TemplateBuilder = lazy(() =>
  import(
    /* webpackChunkName: "TemplateBuilder" */ "../components/TemplateBuilder/TemplateBuilder"
  )
);
const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  pageDiv: {
    minHeight: "100vh",
    width: "100%",
  },
}));

export const templateBuilder = (props) => {
  const { classes } = useStyles();
  const { templateId } = props.match.params;

  return (
    <div className={classes.pageDiv}>
      <CustomMeta
        title={`Template Builder - Content Generator`}
        description={`Design and save custom social media templates for consistent branding. Create reusable post layouts with your brand colors, fonts, and elements to generate professional posts in seconds.`}
        url={`https://contentgenerator.io/template-builder`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Fragment>
          {props.user.authenticated ? (
            <Suspense fallback={<div />}>
              <TemplateBuilder templateId={templateId} />
            </Suspense>
          ) : (
            <Suspense fallback={<div />}>
              <LoginOrSignup />
            </Suspense>
          )}
        </Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(templateBuilder);
